import { Divider, Grid, TextField, Typography } from "@mui/material";
import nameToSlug from "@utils/nameToSlug";
import { useEffect } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";

import type { OrganizationFormSchemaType } from "@/schemas/organization-form";

function EnterpriseName() {
  const {
    formState: { errors },
    getValues,
    control,
    setValue,
  } = useFormContext<OrganizationFormSchemaType>();

  const organizationName = useWatch({
    name: "name",
    control,
  });

  const organizationSlug = useWatch({
    name: "slug",
    control,
  });

  useEffect(() => {
    setValue("slug", nameToSlug(organizationName));
  }, [organizationName, setValue]);

  return (
    <Grid container direction="row" spacing={2} paddingBottom={2}>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h5">Nom de l’entreprise</Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ bgcolor: "#fe5d8d" }} />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              InputLabelProps={getValues("name") ? { shrink: true } : {}}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              fullWidth
              variant="standard"
              label="Nom"
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Controller
          name="slug"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              InputLabelProps={organizationSlug ? { shrink: true } : {}}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              fullWidth
              variant="standard"
              label="Slug"
            />
          )}
        />
      </Grid>
    </Grid>
  );
}

export default EnterpriseName;
